// extracted by mini-css-extract-plugin
export default {"input":"integer_input_input__ZNZOo","toggleIcon":"integer_input_toggleIcon__nBkki","label":"integer_input_label__1-vUK","container":"integer_input_container__YT84m"};